import { useCallback } from 'react';
import { useCampaignBuilderV2Api } from '../api';
import { Campaign, CampaignPayloadParams, SaveMode } from '../types';

export function usePolicyApi() {
  const api = useCampaignBuilderV2Api();

  const save = useCallback(
    (payload: CampaignPayloadParams, mode: SaveMode, ctx: { campaignId?: string; companyId: string }): Promise<{ data: Campaign[] | Campaign }> => {
      if (mode === 'update' && ctx.campaignId) {
        return api.updateCampaign(payload, ctx.campaignId, ctx.companyId);
      }
      return api.createCampaign(payload, ctx.companyId);
    },
    [api],
  );

  return { save };
}
